/* eslint-disable */
import React from 'react';
//import { ClericIndicator } from '../../../pages/account-info/components/cleric-indicator';
import { ContentSpacer } from './generic-content-spacer';
import { dividerSectionStyles } from '../../constants/theme/styles/layout/dividersection-styles';
import { ClericIndicator } from '../../../pages/account-info/components/cleric-indicator';


interface Props {
	sectionText?: string;
	secondarySectionNode?: JSX.Element;
	sectionDescription?: string;
	showCleryIcon?: boolean;
	removeDivider?: boolean;
	greySection?: boolean;
	topDivider?: boolean;
	dashedBorder?: boolean;
	disabledOverlay?: boolean;
}
export const DividerSection = (props: React.PropsWithChildren<Props>) => {
	const dividerSectionClasses = dividerSectionStyles();
	const disabledOverlay = props.disabledOverlay ? dividerSectionClasses.disableSection : '';

	const getDividerClasses = () => {
		if (props.topDivider) {
			return dividerSectionClasses.topDivider;
		}
		if (props.dashedBorder) {
			return `${dividerSectionClasses.dividerSection} dashed-border`;
		}
		return props.removeDivider ? dividerSectionClasses.genericSection : dividerSectionClasses.dividerSection;
	};
	return (
		<>
			<div className={`${getDividerClasses()} ${disabledOverlay}`}>
				<div className={props.greySection ? dividerSectionClasses.grayBackground : ''}>

					<div className={dividerSectionClasses.dividerHeader}>
						<div className='divider-header-inner'>
							{

								props.showCleryIcon ?
									<ClericIndicator /> : null

							}
							<ContentSpacer hide={!props.sectionText}>
								<h2>{props.sectionText}</h2>
							</ContentSpacer>
						</div>

						{props.secondarySectionNode}
					</div>
					<ContentSpacer hide={!props.sectionDescription}>
						<div dangerouslySetInnerHTML={{ __html: props.sectionDescription }} />

					</ContentSpacer>
					<div className={dividerSectionClasses.dividerSectionContent}>
						{props.children}
					</div>
				</div>
			</div >
		</>
	);
};

DividerSection.defaultProps = {
	sectionText: null,
	secondarySectionNode: null,
	sectionDescription: null,
	showCleryIcon: false,
	removeDivider: false,
	greySection: false,
	topDivider: false,
	dashedBorder: false,
	disabledOverlay: false,
};